import React, {useState} from "react";

import icon_directory from "./../../../sources/icons/icon-directory.svg";
import icon_directory_pink from "./../../../sources/icons/icon-directory-pink.svg";


//Herramientas
import DNSDUMPSTER from "./tools/DNSDUMPSTER.jsx";
import WEBMII from "./tools/WEBMII.jsx";
import SHERLOCK from "./tools/SHERLOCK.jsx";
import HOLEHE from "./tools/HOLEHE.jsx";
import DEPIX from "./tools/DEPIX.jsx";
import BETTERCAP from "./tools/BETTERCAP.jsx";

export default function Reconocimiento (props) {

    const [herramienta, setHerramienta] = useState(1)

    return (
        <>
        <h3 className="span-blue">
            <img className="icon-subtitle" src={icon_directory} alt=""/>
            <span className="span-blue"> Fase de Reconocimiento.<span className="span-blue cursor">_</span>
            </span>
        </h3>

        <p>
            A <span className="span-white">continuacion,</span> se muestra la <span className="span-white">lista</span> de <span className="span-pink">herramientas</span> para el  <span className="span-white">Paso del Haking </span> <span className="span-yellow">Fase de Reconocimiento:</span>
        </p>

        <p>
            (<i className="span-yellow">Selecciona</i> una <span className="span-white">herramienta</span> para <span className="span-white">visualizar</span> su <span className="span-pink">documentación</span> e <span className="span-pink">información</span>).
        </p>

        <div className="div-structure-row">
            <a className="a-structure" onClick={() => setHerramienta(1)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> DNSDUMPSTER.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>

            <a className="a-structure" onClick={() => setHerramienta(2)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> WEBMII.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>

            <a className="a-structure" onClick={() => setHerramienta(3)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> SHERLOCK.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>

            <a className="a-structure" onClick={() => setHerramienta(4)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> HOLEHE.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>

            <a className="a-structure" onClick={() => setHerramienta(5)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> DEPIX.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>

            <a className="a-structure" onClick={() => setHerramienta(6)}>
                <h3 className="span-blue">
                    <img className="icon-subtitle" src={icon_directory_pink} alt=""/>
                    <span className="span-pink"> BETTERCAP.<span className="span-pink cursor">_</span>
                    </span>
                </h3>
            </a>
        </div>

        <hr className="cursor"/>

        <p>
            A <span className="span-pink">continuación</span>, la <span className="span-white">documentación</span> e <span className="span-white">información</span> de la <i className="span-yellow">herramienta</i>:
        </p>

        {(() => {
            if (herramienta === 1) {
                return <DNSDUMPSTER
                    funcionNotificacion = {props.funcionNotificacion}
                    notifications = {props.notifications}
                />;
            } else if (herramienta === 2) {
                return <WEBMII
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                />;
            } else if (herramienta === 3) {
                return <SHERLOCK
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                />;
            } else if (herramienta === 4) {
                return <HOLEHE
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                />;
            } else if (herramienta === 5) {
                return <DEPIX
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                />;
            } else if (herramienta === 6) {
                return <BETTERCAP
                funcionNotificacion = {props.funcionNotificacion}
                notifications = {props.notifications}
                />;
            } else {
                return <DNSDUMPSTER
                    funcionNotificacion = {props.funcionNotificacion}
                    notifications = {props.notifications}
                />;
            }
        })()}
    </>
    );
}